import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import { renderField, Validate } from '../../../../../common/form/FieldHelper';
import { getEditModalState } from '../../../selectors';
import * as actions from '../../../actions';
import * as c from '../../../constants';

import ErrorMessage from './ErrorMessage';
import ImageFrame from '../../common/ImageFrame';

import messages from '../../../translation_hotkey_template';


class EditHotkeyForm extends Component {
  constructor(props) {
    super(props);
    this.handleOnFormSubmit = this.handleOnFormSubmit.bind(this);
  }


  validateForm(form) {
    const { name } = form;
    const error = [];

    if (!name) {
      error.push('Name is required.');
    }

    return isEmpty(error) ? undefined : { _error: error };
  }


  handleOnFormSubmit(form) {
    const error = this.validateForm(form);

    if (error) {
      throw new SubmissionError(error);
    }

    const { mode, editChild, editTab, resetEditModal } = this.props;

    (mode === c.MODAL_MODE_EDIT_CHILD)
      ? editChild(form)
      : editTab(form);

    resetEditModal();
  }


  render() {
    const { imageUrl, error, pristine, handleSubmit } = this.props;

    return (
      <div className="ui form basic grid segment ht-marginless" style={{ marginBottom: 5 }}>
        {error &&
          <div className="one column row ht-small-padding">
            <div className="column">
              <ErrorMessage error={error} />
            </div>
          </div>
        }
        <div className="row ht-small-padding">
          <div className="ten wide column">
            <Field
              type="text"
              name="name"
              label="Name"
              component={renderField}
              translation={{label: { message: messages.label_name }}}
            />
            <Field
              type="text"
              name="image_url"
              label="Image URL"
              placeholder="http://"
              component={renderField}
              translation={{label: { message: messages.label_image_url }}}
              validate={[Validate.url]}
            />
          </div>
          <div className="six wide column">
            <ImageFrame src={imageUrl} />
          </div>
        </div>
        <div className="one column row ht-paddingless">
          <div className="column ht-small-padding">
            <div className="ui divider ht-paddingless" style={{ paddingBottom: 5 }}></div>
          </div>
        </div>
        <div className="one column row ht-small-padding">
          <div className="column ht-paddingless">
            <div className={`ui primary ${pristine && "disabled"} right floated button`} onClick={handleSubmit(this.handleOnFormSubmit)}><FormattedMessage id="admin.hotkey_template.form.save" defaultMessage="Save" /></div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state, { formId: form }) {
  const { mode, hotkey } = getEditModalState(state);
  const getField = formValueSelector(form);

  return {
    form,
    mode,
    imageUrl: getField(state, 'image_url'),
    initialValues: hotkey
  };
}


function mapDispatchToProps(dispatch) {
  const { editChild, editTab, resetEditModal } = actions;

  return bindActionCreators({
    resetEditModal,
    editChild,
    editTab
  }, dispatch);
}


EditHotkeyForm = reduxForm({
  enableReinitialize: true
})(EditHotkeyForm);


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(EditHotkeyForm));
